import { IUiIcon } from '../../../types/ui'

export const IconTrendingDown = (
	{
		size = 24,
		imgSize = 24,
		fill = 'none',
		stroke = 'currentColor'
	}: IUiIcon
) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg"
		     width={`${size}px`}
		     height={`${size}px`}
		     viewBox={`0 0 ${imgSize} ${imgSize}`}
		     fill={fill}
		     stroke={stroke}
		     strokeWidth="2"
		     strokeLinecap="round"
		     strokeLinejoin="round"
		     className="feather feather-trending-down"
		>
			<polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline>
			<polyline points="17 18 23 18 23 12"></polyline>
		</svg>
	)
}